import React, { useEffect, useState } from 'react'
import "./BusinessCaseCard.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessCaseRequest } from '../../../../../store/features/actions/opportunities/businessCaseActions';
import { useParams } from "react-router-dom";
import { ValueSellingFrameworkPlaceholder } from "./ValueSellingFramworkPlaceholder";
import NoDataComp from '../../../genericComponents/uiElements/NoDataComp';
import { useTaskStatus } from '../../../../../context/TaskStatusContext';
import GeneratingLoader from '../../../genericComponents/uiElements/GeneratingLoader';

export default function BusinessCaseCard({opportunityId, opportunityName}) {

  const dispatch = useDispatch();
  const { clientName, accountName } = useParams();
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const {businessCaseData, businessCaseLoading, error}= useSelector(state=>state?.businessCaseReducer)


      const { getTaskStatus } = useTaskStatus();
      const taskStatus = getTaskStatus(`opp_sidecard_business_case_slide_${opportunityId}`);
    
      useEffect(() => {
        if (taskStatus=="completed") {
          if (opportunityId?.length) {
            dispatch(fetchBusinessCaseRequest({opportunityId}))
          }
        }
      }, [taskStatus])

  useEffect(() => {
    if (opportunityId?.length) {
      dispatch(fetchBusinessCaseRequest({opportunityId}))
    }
  }, [opportunityId])

  useEffect(() => {
    if (businessCaseData) {
      setResult(businessCaseData);
      setStatus("Completed!");
    } else if (error) {
      setStatus("Error loading data");
    }
  }, [businessCaseData, error]);

  if (taskStatus=="pending" && taskStatus!="failed") {  
    return(
    <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
      <GeneratingLoader/>
    </div>)
  }

  return (
    <div className='m-2'>
      {businessCaseLoading === true || result === null ? (
        <div className="businessCaseWrapper">
          {/* <ValueSellingFrameworkPlaceholder
            numberOfCards={1}
            widthClass="col-md-12"
            numberOfLines={15}
          /> */}

          {/* Card 1 Placeholder */}
          <div className="custom-card mb-4">
            <div class="angled-bg placeholder"></div>
            <div class="content_business_card">
              <h1 className="placeholder-glow">
                <h1>
                  <span class="placeholder col-7"></span>
                  <span class="placeholder col-6"></span>
                  <div><span class="placeholder col-3"></span></div>
                </h1>
              </h1>
              <div className="lead col-md-4">
                <p class="card-text placeholder-glow">
                  <span class="placeholder col-7"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-6"></span>
                  <span class="placeholder col-8"></span>
                </p>
              </div>

              <div className="lead col-md-4 placeholder-glow">
                <h5><span className="placeholder col-12" style={{ height: '1.5rem' }}></span></h5>
              </div>

            </div>

          </div>

          {/* Card 2 Placeholder */}
          <div className="custom-card mb-4 position-relative">
            <div className="angled-bg placeholder" style={{ width: '20%', opacity: '0.2' }}></div>
            <div className="content mt-2 p-3">
              <h2 className="placeholder-glow">
                <span className="placeholder col-4" style={{ height: '1.5rem' }}></span>
              </h2>
              <p className="placeholder-glow">
                <span className="placeholder col-10"></span>
                <span className="placeholder col-8"></span>
              </p>

              <h2 className="placeholder-glow">
                <span className="placeholder col-3" style={{ height: '1.5rem' }}></span>
              </h2>
              <ul className="list-unstyled">
                {[...Array(3)].map((_, i) => (
                  <li key={i} className="placeholder-glow">
                    <span className="placeholder col-9"></span>
                  </li>
                ))}
              </ul>

              <h2 className="placeholder-glow">
                <span className="placeholder col-3" style={{ height: '1.5rem' }}></span>
              </h2>
              <ul className="list-unstyled">
                {[...Array(3)].map((_, i) => (
                  <li key={i} className="placeholder-glow">
                    <span className="placeholder col-9"></span>
                  </li>
                ))}
              </ul>
            </div>
          </div>


          {/* Card 3 Placeholder */}
          <div className="custom-card mb-4 position-relative">
            <div className="angled-bg placeholder" style={{ width: '20%', opacity: '0.2' }}></div>
            <div className="content mt-2 p-3">
              <h2 className="placeholder-glow">
                <span className="placeholder col-4" style={{ height: '1.5rem' }}></span>
              </h2>
              <p className="placeholder-glow">
                <span className="placeholder col-10"></span>
                <span className="placeholder col-8"></span>
              </p>

              <h2 className="placeholder-glow">
                <span className="placeholder col-6" style={{ height: '1.5rem' }}></span>
              </h2>
              <ul className="list-unstyled">
                {[...Array(3)].map((_, i) => (
                  <li key={i} className="placeholder-glow">
                    <span className="placeholder col-6"></span>
                  </li>
                ))}
              </ul>

            </div>
          </div>

          
          
        </div>
      ): Object.keys(result).length === 0 ? (
        <div className="no-data-message">
          <NoDataComp
           message="Content is being generated"
           buttonText="Refresh"
           onButtonClick={() =>  dispatch(fetchBusinessCaseRequest({opportunityId}))}
        />
      </div>
      ) : (
        <div className="businessCaseWrapper">
          <div class="custom-card mb-4">
            <div class="content_business">
              <h1 className='head_business'>{opportunityName}</h1>
              <div className="sub_head_block col-md-6">
                <h5 className='sub_head_bus'>{result?.[0]?.strategic_context}</h5>
              </div>
            </div>
          </div>

          <div class="custom-card-single mb-4">
        
            <div class="content_business">
              <h2 className='content_business_h2'>2. Opportunity to Accelerate</h2>
              <p className='content_business_p'>{result?.[0]?.opportunity_to_accelerate}</p>

              <h2 className='content_business_h2'>3. Business Impact</h2>
              <ul class="list-unstyled content_business_list">
                {result?.[0]?.business_impact.map((v, index) => {
                  return (
                    <li className='content_business_list'>
                      <span class="check"> <img src="/img/checkmark.png" className="checkmark_img"/></span> {v}
                    </li>
                  );
                })}
              </ul>

              <h2 className='content_business_h2'>4. Why {clientName}</h2>
              <ul class="list-unstyled content_business_list">
                {result?.[0]?.why_seller_is_the_strategic_partner.map(
                  (v, index) => {
                    return (
                      <li className='content_business_list'>
                        <span class="check"><img src="/img/checkmark.png" className="checkmark_img"/></span> {v}
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
          </div>

          <div class="custom-card-single">
          
            <div class="content_business mt-2">
              <h2 className='content_business_h2'>5. Risk of Inaction</h2>
              <p className='content_business_p'>{result?.[0]?.risk_of_inaction}</p>

              <h2 className='content_business_h2'>6. Next Step</h2>
              <p className='content_business_p'>{result?.[0]?.next_step_cta}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
